import { Variant } from 'react-bootstrap/esm/types';

export const getIconColorBySeverity = (severity: Variant) => {
  const colorClassMapper = {
    [severity]: `text-${severity}`,
    warning: 'text-warning-lighter',
  };

  return colorClassMapper[severity];
};
